module.exports = __webpack_public_path__ + "img/img_polaroid_quilt04@3x.c075c7c1.png";